import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import 'next/stylesheets/components/scroll-load-trigger.scss';

Component('tr-scroll-load-trigger', {
  mixins: [eventListenerMixin],

  properties: {
    scrollContainerSelector: String,
    loading: {
      type: Boolean,
      default: false,
    },
    topOffset: {
      type: Number,
      default: 20,
    },
    checkOnReady: {
      type: Boolean,
      default: true,
    },
  },

  ready() {
    if (this.scrollContainerSelector) {
      this.scrollContainer = document
        .querySelector(this.scrollContainerSelector) || window;
    } else {
      this.scrollContainer = window;
    }

    this.listenTo(this.scrollContainer, 'scroll', this.checkScroll.bind(this));
    this.listenTo(this.scrollContainer, 'resize', this.checkScroll.bind(this));
    if (this.checkOnReady) this.checkScroll();
  },

  checkScroll() {
    const { top: rectTop } = this.getBoundingClientRect();
    const containerRectBottom = this.getScrollContainerRectBottom();
    if (this.loading || rectTop > containerRectBottom + this.topOffset) return;

    this.loading = true;
    this.namespacedTrigger('loading', { bubbles: true });
  },

  getScrollContainerRectBottom() {
    let bottom;
    if (this.scrollContainer === window) {
      bottom = window.innerHeight;
    } else {
      ({ bottom } = this.scrollContainer.getBoundingClientRect());
    }
    return bottom;
  },

  disconnected() {
    this.stopListening();
  },
});
